import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { SentimentGroup } from '../model/sentimentgroup';

@Injectable()
export class SentimentGroupService {
  private apiURL = APP_SETTINGS.MarketToolBOApiUrl;

  constructor(
    private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }

  public Get(locale: string): Observable<SentimentGroup[]> {
    const url = `${this.apiURL}api/${locale}/sentimentgroupmanager`;
    return this.executeService.ExecuteWithToken('get', url)
    .pipe(
        catchError(this.errorHandler.handleError('SentimentGroupService_Get', [], true))
    );
  }

  public GetById(locale: string, id: string): Observable<SentimentGroup> {
    const url = `${this.apiURL}api/${locale}/sentimentgroupmanager/${id}`;
    return this.executeService.ExecuteWithToken('get', url)
    .pipe(
      catchError(this.errorHandler.handleError('SentimentGroupService_Get', [], true))
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/sentiment/services/sentimentgroup.service.ts